import moment from 'moment'
import { LanguageEnum } from 'enums'
import humanizeDuration from 'humanize-duration'

export const displayTimeByLang = (dateTime: string, lang) => {
  const time = moment(dateTime).format('LT')
  return lang === LanguageEnum.en ? time : `${time} น.`
}

export const displayRemainingTime = (endTime: string, language: string) => {
  const now = moment()
  const _endTime = moment(endTime)

  return humanizeDuration(_endTime.diff(now), {
    language,
    conjunction: ' ',
    serialComma: false,
    units: ['h', 'm'],
    round: true,
  })
}
